// Events.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import Header from '../repeat/Header';
import Footer from '../repeat/Footer';
import Data from './code/Data';

const Events = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  // Function to handle the button click and navigate to the login page
  const handleLoginClick = () => {
    navigate("/login"); // Navigate to the login page
  };

  return (
    <div>
      <div>
        <Header />
      </div>
      <div>
        <Data />
      </div>
      <div>
        <Footer />
      </div>

      {/* Button to navigate to the login page */}
      {/* <button className="go-to-login-btn" onClick={handleLoginClick}>
        Go to Login
      </button> */}
    </div>
  );
}

export default Events;
